var app = angular.module("leonardo");

var ActionsOverviewController = function($scope, ngDialog, FilterService, PropertyGroupService) {

  $scope.doExport = function(){
    var filters = {
      account: FilterService.getFilter('account_reports'),
      group: FilterService.getFilter('group_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      id: FilterService.getFilter('property_reports'),
      category: FilterService.getFilter('category'),
      priority: FilterService.getFilter('priority'),
      group_by: FilterService.getFilter('group_by'),
      managed_by: FilterService.getFilter('managed_by_reports'),
      property_status: FilterService.getFilter('property_status')
    };
    ngDialog.open({
      template: 'views/templates/dialog/overview/export.html',
      className: 'ngdialog-theme-default ngdialog-export',
      controller: 'ExportOverviewDialog',
      data: {
        filters: filters
      }
    });
  };

  $scope.getgroups = function(ids){
    PropertyGroupService.getGroups(ids).then(function (data) {
      if (data) {
        ngDialog.open({
          template: 'views/templates/dialog/report/group-error.html'
        });
      } else {
        $scope.doExport();
      }
    });
  }

  $scope.export = function () {
    if (FilterService.hasFilter('group_by') && FilterService.getFilter('group_by') === 'group') {
      if(FilterService.hasFilter('group_reports')){
        var groups_Ids = FilterService.getFilter('group_reports').toString().split(',');
        if (groups_Ids.length > 1) {
          $scope.getgroups(groups_Ids);
        } else {
          $scope.doExport();
        }
      }else{
        $scope.getgroups();
      }
    } else {
      $scope.doExport();
    }
  };


};

app.controller('ActionsOverviewController', ['$scope', 'ngDialog', 'FilterService', 'PropertyGroupService',
  ActionsOverviewController]);
